import type { File as ServiceFile } from '@printdeal/services-sdk';
import Api from '../Api';

export type ProposalAction = 'approve' | 'reject' | 'close';

export interface ProposalActionInput {
  action: ProposalAction;
  comments?: string;
}

interface ProposalActionPayload {
  accountId: string;
  proposalId: string;
  customerAction: ProposalAction;
}

type ProposalStatus = | 'AwaitingCustomerConfirmation'
  | 'AwaitingForAdjustment'
  | 'Rejected'
  | 'Closed';

export type ProposalIterationStatus = | 'AwaitingConfirmation'
  | 'Approved'
  | 'Rejected'
  | 'Closed';

interface CheckItResponseObject {
  documentReferenceUrl: string;
  renderingInstructionsUrl: string;
}

interface CheckItResponseArrayElement {
  Action: {
    modifiedFileUrl: Array<string>;
    originalFileUrl: string;
  };
  FileName: string;
}

export type CheckItResponse = CheckItResponseObject | CheckItResponseArrayElement[];

export type ProposalIterationModifiedFile = {
  pdfUrl?: string;
  previewUrls?: string[];
  modifiedUrl?: string;
};

export type ProposalIteration = {
  id: string;
  userFile: string[];
  modifiedFile: ProposalIterationModifiedFile;
  checkItResponse: CheckItResponse;
  status: ProposalIterationStatus;
  auxCodes: Array<string> | undefined;
  referenceFiles?: ServiceFile[];
  agentComments: string;
  customerComments: string;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  artworkReviewer: string;
  reviewRequestId: string;
  requestedBy: string;
};

type Proposal = {
  id: string;
  proposalType: 'Proposal Flow Test' | string;
  orderId: string;
  lineItemId: string;
  customerId: string;
  lineItemNumber: string;
  status: ProposalStatus;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  iterations: Array<ProposalIteration>;
};

interface ProposalData {
  comments?: string;
}

class FileReviewService extends Api {
  async actOnProposal(proposalPayload: ProposalActionPayload, proposalData?: ProposalData) {
    const { proposalId, accountId, customerAction } = proposalPayload;
    const { data } = await this.httpClient.post(
      `/customers/${accountId}/proposals/${proposalId}/${customerAction}`,
      proposalData,
    ).catch(this.errorHandler);
    return data;
  }

  async getProposal(accountId: string, proposalId: string) {
    const { data } = await this.httpClient.get<{ data: Proposal }>(
      `/customers/${accountId}/proposals/${proposalId}`,
    ).catch(this.errorHandler);
    return data.data;
  }
}

export default FileReviewService;
